export default "__VITE_ASSET__D8N3bLtt__"